import { Capacitor } from "@capacitor/core";
import { ColoursObj } from "@eventr/common-storybook";
import { Toast } from "@eventr/native/toast";
import { AlertColor } from "@mui/material";

const SEVERITY_ICON: Record<AlertColor, string> = {
  error: "exclamationmark.triangle.fill",
  warning: "exclamationmark.triangle.fill",
  success: "checkmark.circle.fill",
  info: "info.circle.fill",
};

const SEVERITY_COLOR_HEX: Record<AlertColor, string> = {
  error: ColoursObj.states.error,
  warning: ColoursObj.states.warning,
  success: ColoursObj.states.success,
  info: ColoursObj.font.primary,
};

export function isIosToastAvailable(): boolean {
  return Capacitor.isPluginAvailable("Toast");
}

export async function showNativeSnack(message: string, severity: AlertColor, stack: boolean): Promise<void> {
  if (!stack) {
    await Toast.hideAll().catch(() => {});
  }
  await Toast.show({
    lines: [message],
    iconSystemName: SEVERITY_ICON[severity],
    accentColorHex: SEVERITY_COLOR_HEX[severity],
  }).catch(() => {});
}
